import { render, staticRenderFns } from "./CronJobs.vue?vue&type=template&id=1b050688"
import script from "./CronJobs.vue?vue&type=script&lang=js"
export * from "./CronJobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports